import { ScopeAndStream } from '@/routes/carbon_footprint/routes/emissions/constants';
import { EmissionScope, EmissionStream } from '@enmon/commons/lib/shared/emissions';
import { EMISSION_SCOPE_TRANSLATED } from './emissionScope';

export const EMISSION_SCOPE_AND_STREAM_TRANSLATED = {
  [ScopeAndStream.One]: `Scope ${EMISSION_SCOPE_TRANSLATED[EmissionScope.One]}`,
  [ScopeAndStream.TwoUpstream]: `Scope ${EMISSION_SCOPE_TRANSLATED[EmissionScope.Two]}`,
  [ScopeAndStream.ThreeDownstream]: `Scope ${EMISSION_SCOPE_TRANSLATED[EmissionScope.Three]} ${EmissionStream.Down}`,
  [ScopeAndStream.ThreeUpstream]: `Scope ${EMISSION_SCOPE_TRANSLATED[EmissionScope.Three]} ${EmissionStream.Up}`,
};
